import { BaseEntity } from "yt-ng-framework";

export class TrosakDokumentStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    VrstaTroska: string;
    OrgJed: string;
    Iznos: number;
    VrstaTroskaID: number;

    Deserialize(input:any){
        this.ID=input.ID;
        this.VrstaTroska=input.VrstaTroska;
        this.OrgJed = input.OrgJed;
        this.Iznos=input.Iznos;
        this.VrstaTroskaID = input.VrstaTroskaID;        
        return this;
    }

    Serialize(input:TrosakDokumentStavkaView){
        return input;
    }
}